import DownloadWellDataReportModal from './containers/DownloadWellDataReportModalContainer'

export default DownloadWellDataReportModal
